import "./styles.css"

export function ButtonExportPDF() {
    return (<>
        <button
            className="buttonExportPdf no-print"
            onClick={() => {
                window.print()
            }}
            type="button"
        >
            Exportar PDF
        </button>
        <div className="spacePrint" />
    </>)
}